var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('el-card',{staticClass:"preview"},[_c('Preview',{attrs:{"repo_id":_vm.repoID}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }